import React from 'react';
import { modalConfig, initialSetting } from 'configs';

const ModalManager = {
	modal: React.createRef(),

	show(key, setting, replace = false) {

		let arg = {
			...initialSetting,
			...setting,
		}

		if (typeof key === 'string') {
			arg = { ...arg, ...modalConfig[key] };
		}
		else {
			arg = { ...arg, ...key };
		}

		this.modal.current.show(arg, replace);
	},

	updateSetting(setting) {
		this.modal.current.updateSetting(setting);
	},

	hide(key) {
		return new Promise((resolve, reject) => {
			this.modal?.current?.hide(key);

			resolve(true);
		});
	},

	hideAll() {
		this.modal.current.hideAll();
	},
};

export default ModalManager;